<p-toast position="bottom-right"></p-toast>
<p-confirmDialog></p-confirmDialog>

<div style="background-color: rgb(0, 152, 223); height: 5px;" class="ng-star-inserted"></div>

<div class="container-fluid mt-3">
  <p-panel header="Gerenciamento de Erros da Aplicação" styleClass="p-shadow-3">
    
    <!-- Cards de Estatísticas -->
    <div class="row mb-3">
      <div class="col-md-4">
        <div class="card text-white bg-primary">
          <div class="card-body">
            <h5 class="card-title">Total de Erros</h5>
            <h2 class="card-text">{{totalErros}}</h2>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card text-white bg-warning">
          <div class="card-body">
            <h5 class="card-title">Últimas 24 horas</h5>
            <h2 class="card-text">{{errosRecentes24h}}</h2>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card text-white bg-danger">
          <div class="card-body">
            <h5 class="card-title">Últimos 7 dias</h5>
            <h2 class="card-text">{{errosRecentes7d}}</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Toolbar com ações -->
    <p-toolbar styleClass="mb-3">
      <ng-template pTemplate="left">
        <button pButton pRipple label="Atualizar" icon="pi pi-refresh" class="p-button-success mr-2" 
                (click)="carregarErros()"></button>
        <button pButton pRipple label="Exportar TXT" icon="pi pi-file" class="p-button-info mr-2" 
                (click)="exportarParaTxt()" [disabled]="erros.length === 0"></button>
        <button pButton pRipple label="Deletar Todos" icon="pi pi-trash" class="p-button-danger mr-2" 
                (click)="confirmarDeletarTodos()" [disabled]="erros.length === 0"></button>
        <button pButton pRipple label="Ignorar Erros" icon="pi pi-ban" class="p-button-warning" 
                (click)="abrirModalIgnorarErros()"></button>
      </ng-template>
      
      <ng-template pTemplate="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="filtrarGlobal($event)" 
                 placeholder="Buscar em todos os campos..." 
                 style="width: 300px;" />
        </span>
      </ng-template>
    </p-toolbar>

    <!-- Tabela de Erros -->
    <p-table 
      #dt 
      [value]="errosFiltrados" 
      [loading]="loading" 
      [columns]="cols" 
      [rows]="20"
      [paginator]="true"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} erros"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
      [autoLayout]="true"
      [scrollable]="true"
      scrollHeight="500px">
      
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="cols.length + 1" class="text-center bg-no-records p-shadow-3" style="padding: 20px;">
            <i class="pi pi-check-circle" style="font-size: 3rem; color: #4caf50;"></i>
            <p class="text-muted mt-2" style="font-size: 1.2rem;">Nenhum erro registrado</p>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}"
              style="background-color:#212529; color:white; border-color: rgb(105, 105, 105);">
            {{col.header}}
          </th>
          <th style="background-color:#212529; color:white; border-color: rgb(105, 105, 105); width: 72px;">
            Ações
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-erro let-columns="columns">
        <tr>
          <td style="width: 80px;">
            {{erro.id}}
          </td>
          <td style="width: 180px;">
            {{formatarData(erro.dataOcorrencia)}}
          </td>
          <td style="width: 400px;">
            <span [pTooltip]="erro.mensagem" tooltipPosition="top" tooltipStyleClass="tooltip-prewrap" class="text-truncate d-inline-block" 
                  style="max-width: 380px;">
              {{erro.mensagem}}
            </span>
          </td>
          <td style="width: 300px;">
            <span [pTooltip]="erro.classe" tooltipPosition="top" tooltipStyleClass="tooltip-prewrap" class="text-truncate d-inline-block" 
                  style="max-width: 280px;">
              {{erro.classe}}
            </span>
          </td>
          <td style="width: 150px;">{{erro.metodo}}</td>
          <td style="width: 250px;">
            <span [pTooltip]="erro.path" tooltipPosition="top" tooltipStyleClass="tooltip-prewrap" class="text-truncate d-inline-block" 
                  style="max-width: 230px;">
              {{erro.path}}
            </span>
          </td>
          <td style="width: 250px;">
            <span [pTooltip]="formatarValorDetalhe(erro.payload)" tooltipPosition="top" tooltipStyleClass="tooltip-prewrap" class="text-truncate d-inline-block" 
                  style="max-width: 230px;">
              {{resumirValor(erro.payload)}}
            </span>
          </td>
          <td style="width: 250px;">
            <span [pTooltip]="formatarValorDetalhe(erro.params)" tooltipPosition="top" tooltipStyleClass="tooltip-prewrap" class="text-truncate d-inline-block" 
                  style="max-width: 230px;">
              {{resumirValor(erro.params)}}
            </span>
          </td>
          <td style="width: 100px;">
            <span class="p-badge" 
                  [ngClass]="{
                    'p-badge-success': erro.httpMethod === 'GET',
                    'p-badge-info': erro.httpMethod === 'POST',
                    'p-badge-warning': erro.httpMethod === 'PUT',
                    'p-badge-danger': erro.httpMethod === 'DELETE'
                  }">
              {{erro.httpMethod}}
            </span>
          </td>
          <td style="width: 72px; white-space: nowrap;">
            <button pButton pRipple type="button" icon="pi pi-eye" 
                    class="p-button-rounded p-button-info" 
                    style="width: 28px; height: 28px; padding: 0; font-size: 0.85rem; margin-right: 2px;"
                    pTooltip="Ver Detalhes" tooltipPosition="top"
                    (click)="verDetalhes(erro)"></button>
            <button pButton pRipple type="button" icon="pi pi-trash" 
                    class="p-button-rounded p-button-danger" 
                    style="width: 28px; height: 28px; padding: 0; font-size: 0.85rem;"
                    pTooltip="Deletar" tooltipPosition="top"
                    (click)="confirmarDelecao(erro)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>

<!-- Dialog para Detalhes do Erro -->
<p-dialog 
  [(visible)]="displayDialog" 
  [header]="'Detalhes do Erro #' + erroSelecionado?.id" 
  [modal]="true" 
  position="center"
  [style]="{width: '60vw', maxHeight: '80vh'}"
  [draggable]="false"
  [resizable]="true">
  
  <div *ngIf="erroSelecionado">
    <div class="row mb-3">
      <div class="col-md-6">  
        <h6 class="text-primary">Informações Gerais</h6>
        <table class="table table-sm table-bordered">
          <tbody>
            <tr>
              <td class="font-weight-bold" style="width: 40%;">ID:</td>
              <td>{{erroSelecionado.id}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">Data/Hora:</td>
              <td>{{formatarData(erroSelecionado.dataOcorrencia)}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">HTTP Method:</td>
              <td>
                <span class="p-badge" 
                      [ngClass]="{
                        'p-badge-success': erroSelecionado.httpMethod === 'GET',
                        'p-badge-info': erroSelecionado.httpMethod === 'POST',
                        'p-badge-warning': erroSelecionado.httpMethod === 'PUT',
                        'p-badge-danger': erroSelecionado.httpMethod === 'DELETE'
                      }">
                  {{erroSelecionado.httpMethod}}
                </span>
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Endpoint:</td>
              <td><code>{{erroSelecionado.path}}</code></td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="col-md-6">
        <h6 class="text-primary">Localização no Código</h6>
        <table class="table table-sm table-bordered">
          <tbody>
            <tr>
              <td class="font-weight-bold" style="width: 40%;">Arquivo:</td>
              <td><code>{{erroSelecionado.arquivo}}</code></td>
            </tr>
            <tr>
              <td class="font-weight-bold">Classe:</td>
              <td><code>{{erroSelecionado.classe}}</code></td>
            </tr>
            <tr>
              <td class="font-weight-bold">Método:</td>
              <td><code>{{erroSelecionado.metodo}}</code></td>
            </tr>
            <tr>
              <td class="font-weight-bold">Payload:</td>
              <td>
                <pre class="mb-0" style="white-space: pre-wrap; word-wrap: break-word;">{{formatarValorDetalhe(erroSelecionado.payload)}}</pre>
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Parâmetros:</td>
              <td>
                <pre class="mb-0" style="white-space: pre-wrap; word-wrap: break-word;">{{formatarValorDetalhe(erroSelecionado.params)}}</pre>
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Linha:</td>
              <td><span class="p-badge p-badge-warning">{{erroSelecionado.linha}}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mb-3">
      <h6 class="text-primary">Mensagem do Erro</h6>
      <p-panel>
        <pre class="mb-0" style="white-space: pre-wrap; word-wrap: break-word;">{{erroSelecionado.mensagem}}</pre>
      </p-panel>
    </div>

    <div>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="text-primary mb-0">Stacktrace Completo</h6>
        <button pButton type="button" label="Copiar" icon="pi pi-copy" 
                class="p-button-sm p-button-secondary" 
                (click)="copiarStacktrace()"></button>
      </div>
      <p-panel>
        <pre class="mb-0" style="white-space: pre-wrap; word-wrap: break-word; max-height: 400px; overflow-y: auto; font-size: 0.85rem; background-color: #f5f5f5; padding: 10px;">{{erroSelecionado.stacktrace}}</pre>
      </p-panel>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Deletar Erro" icon="pi pi-trash" 
            class="p-button-danger" 
            (click)="confirmarDelecao(erroSelecionado); displayDialog = false"></button>
    <button pButton type="button" label="Fechar" icon="pi pi-times" 
            class="p-button-secondary" 
            (click)="displayDialog = false"></button>
  </ng-template>
</p-dialog>

<!-- Dialog para Ignorar Erros -->
<p-dialog 
  [(visible)]="displayDialogIgnorar" 
  header="Gerenciar Erros Ignorados" 
  [modal]="true" 
  position="center"
  [style]="{width: '70vw', maxHeight: '85vh'}"
  [draggable]="false"
  [resizable]="true">
  
  <p-tabView>
    <!-- Aba: Classes Disponíveis para Ignorar -->
    <p-tabPanel header="Classes Disponíveis" [selected]="true">
      <div *ngIf="loadingIgnorar" class="text-center p-4">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
        <p class="mt-2">Carregando...</p>
      </div>
      
      <div *ngIf="!loadingIgnorar">
        <div class="mb-3">
          <p class="text-muted">
            Selecione as classes que deseja ignorar. Todas as mensagens associadas serão desconsideradas.
          </p>
          <p class="text-info">
            <i class="pi pi-info-circle"></i> 
            Classes/métodos selecionados: <strong>{{classesSelecionadas.length}}</strong>
          </p>
        </div>

        <div *ngIf="classesDisponiveis.length === 0" class="text-center p-4">
          <i class="pi pi-check-circle" style="font-size: 3rem; color: #4caf50;"></i>
          <p class="text-muted mt-2">Não há classes disponíveis para ignorar</p>
        </div>

        <div *ngIf="classesDisponiveis.length > 0" style="max-height: 400px; overflow-y: auto;">
          <table class="table table-hover table-sm">
            <thead>
              <tr>
                <th>Classe</th>
                <th>Método</th>
                <th style="width: 150px;">Qtd. Mensagens</th>
                <th style="width: 40px;"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let classe of classesDisponiveis">
                <tr 
                  [class.table-active]="classe.selecionado"
                  style="cursor: pointer;"
                  (click)="toggleClasseSelecionada(classe)">
                  <td>
                    <code>{{classe.classe}}</code>
                  </td>
                  <td>
                    <code>{{classe.metodo}}</code>
                  </td>
                  <td>
                    {{classe.mensagens.length}}
                  </td>
                  <td class="text-center">
                    <i class="pi"
                       [ngClass]="{
                         'pi-chevron-down': classe.expandido,
                         'pi-chevron-right': !classe.expandido
                       }"
                       style="font-size: 0.9rem;"
                       (click)="toggleExpandClasseDisponivel(classe, $event)"></i>
                  </td>
                </tr>
                <tr *ngIf="classe.expandido">
                  <td colspan="4" style="background-color: #f8f9fa;">
                    <div *ngIf="classe.mensagens.length === 0" class="text-muted">
                      Nenhuma mensagem registrada para esta classe.
                    </div>
                    <div *ngFor="let mensagem of classe.mensagens; let i = index"
                         [ngStyle]="{'border-bottom': i === classe.mensagens.length - 1 ? 'none' : '1px solid #e0e0e0'}"
                         style="padding: 6px 0;">
                      {{mensagem}}
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div class="mt-3 text-right">
          <button pButton type="button" label="Ignorar Classes Selecionadas" icon="pi pi-ban" 
                  class="p-button-warning" 
                  [disabled]="classesSelecionadas.length === 0"
                  (click)="ignorarErrosSelecionados()"></button>
        </div>
      </div>
    </p-tabPanel>

    <!-- Aba: Classes Já Ignoradas -->
    <p-tabPanel header="Classes Ignoradas">
      <div *ngIf="loadingIgnorar" class="text-center p-4">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
        <p class="mt-2">Carregando...</p>
      </div>
      
      <div *ngIf="!loadingIgnorar">
        <div class="mb-3">
          <p class="text-muted">
            Lista de classes que estão sendo ignoradas. Todas as mensagens destas classes são desconsideradas.
          </p>
        </div>

        <div *ngIf="errosIgnorados.length === 0" class="text-center p-4">
          <i class="pi pi-info-circle" style="font-size: 3rem; color: #2196F3;"></i>
          <p class="text-muted mt-2">Nenhuma classe está sendo ignorada no momento</p>
        </div>

        <div *ngIf="errosIgnorados.length > 0" style="max-height: 400px; overflow-y: auto;">
          <table class="table table-hover table-sm">
            <thead>
              <tr>
                <th>Classe</th>
                <th>Método</th>
                <th style="width: 40px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let erroIgnorado of errosIgnorados">
                <td>
                  <code>{{erroIgnorado.classe}}</code>
                </td>
                <td>
                  <code>{{erroIgnorado.metodo}}</code>
                </td>
                <td class="text-center">
                  <button pButton pRipple type="button" icon="pi pi-times" 
                          class="p-button-rounded p-button-danger" 
                          style="width: 24px; height: 24px; padding: 0; font-size: 0.75rem;"
                          pTooltip="Remover da lista de ignorados" tooltipPosition="top"
                          (click)="removerClasseIgnorada(erroIgnorado)"></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Fechar" icon="pi pi-times" 
            class="p-button-secondary" 
            (click)="displayDialogIgnorar = false"></button>
  </ng-template>
</p-dialog>

